import { render, staticRenderFns } from "./yzintegralset_edit.vue?vue&type=template&id=2d724790&scoped=true&"
import script from "./yzintegralset_edit.vue?vue&type=script&lang=js&"
export * from "./yzintegralset_edit.vue?vue&type=script&lang=js&"
import style0 from "./yzintegralset_edit.vue?vue&type=style&index=0&id=2d724790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d724790",
  null
  
)

export default component.exports